/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import ImportModel, { ImportState } from 'cio/models/import';
import AuthService from 'cio/services/auth';

interface ImportsRowArgs {
  import: ImportModel;
  showDescription?: boolean;
}

export default class ImportsRow extends Component<ImportsRowArgs> {
  @service auth!: AuthService;

  // for some reason the linter thinks this is non-exhaustive, but TS typechecks
  // it correctly.
  // eslint-disable-next-line getter-return
  get importState(): { label: string; class: null | string } {
    // Imports are marked as complete when successfully saved and send to the
    // queue workers, but from the user's perspective they aren't actually
    // finished, since all rows may not have been processed by the queue yet.
    // In this case, the import is processing, but not actually complete yet.

    // In case the ingress message is split into multiple messages when the
    // number of attributes are more than 30, rowsImported will be higher than rowsToImport
    // https://github.com/customerio/opsbugs/issues/3238
    if (
      this.args.import.state === ImportState.Imported &&
      this.args.import.rowsToImport > this.args.import.rowsImported
    ) {
      return {
        label: 'Processing',
        class: 'is-warning',
      };
    }

    switch (this.args.import.state) {
      case ImportState.Start:
        return {
          label: 'Created',
          class: null,
        };
      case ImportState.Preprocessing:
        return {
          label: 'Validating Data',
          class: 'is-warning',
        };
      case ImportState.Preprocessed:
        return {
          label: 'Needs Attention',
          class: 'is-warning',
        };
      case ImportState.Validating:
        return {
          label: 'Validating',
          class: 'is-warning',
        };
      case ImportState.Validated:
        return {
          label: 'Validated',
          class: 'is-warning',
        };
      case ImportState.Importing:
        return {
          label: 'Importing',
          class: 'is-warning',
        };
      case ImportState.Imported:
        return {
          label: 'Complete',
          class: 'is-success',
        };
      case ImportState.Failed:
        return {
          label: 'Failed',
          class: 'is-danger',
        };
      case ImportState.Canceled:
        return {
          label: 'Canceled',
          class: null,
        };
    }
  }

  get exportDisabled() {
    return (
      !this.auth.hasPermission('journeys/exports/create') || !this.args.import.canImport || this.args.import.isExpired
    );
  }
}
